/* Almond Hair — shared scroll-snap carousel controller
   Usage: wrapper[data-ah-carousel] containing:
     [data-ah-track]  scrollable snap track
     [data-ah-prev] / [data-ah-next]  optional buttons
     [data-ah-progress] > [data-ah-fill]  optional progress bar
     [data-ah-dots]  optional dot container (dots auto-generated) */
(function () {
  'use strict';

  function init(root) {
    if (root.__ahInit) return;
    root.__ahInit = true;

    var track = root.querySelector('[data-ah-track]');
    if (!track) return;
    var prev = root.querySelector('[data-ah-prev]');
    var next = root.querySelector('[data-ah-next]');
    var fill = root.querySelector('[data-ah-fill]');
    var dotsBox = root.querySelector('[data-ah-dots]');
    var count = root.querySelector('[data-ah-count]');
    var rtl = (window.getComputedStyle ? getComputedStyle(track).direction : document.documentElement.getAttribute('dir')) === 'rtl';

    function items() {
      return Array.prototype.slice.call(track.children).filter(function (el) {
        return el.offsetParent !== null || el.offsetWidth > 0;
      });
    }

    function step() {
      var list = items();
      if (list.length < 2) return track.clientWidth * 0.9;
      return Math.abs(list[1].offsetLeft - list[0].offsetLeft) || track.clientWidth * 0.9;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function pos() {
      return Math.abs(track.scrollLeft);
    }

    function update() {
      var max = maxScroll();
      var p = max > 0 ? Math.min(1, pos() / max) : 1;
      if (fill) fill.style.width = Math.max(p * 100, max > 0 ? 8 : 100) + '%';
      if (prev) prev.toggleAttribute('disabled', pos() < 4);
      if (next) next.toggleAttribute('disabled', pos() > max - 4);
      if (dotsBox) {
        var idx = Math.round(pos() / step());
        Array.prototype.forEach.call(dotsBox.children, function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }
      if (count) {
        var total = Math.max(1, Math.round(maxScroll() / step()) + 1);
        var cur = Math.min(total, Math.round(pos() / step()) + 1);
        count.textContent = cur + ' / ' + total;
      }
      root.classList.toggle('ah-c--no-overflow', max <= 4);
    }

    function go(dir) {
      var delta = step() * dir * (rtl ? -1 : 1);
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    if (dotsBox) {
      var count = Math.max(1, Math.round(maxScroll() / step()) + 1);
      dotsBox.innerHTML = '';
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ah-c__dot';
          b.setAttribute('aria-label', 'Slide ' + (idx + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: idx * step() * (rtl ? -1 : 1), behavior: 'smooth' });
          });
          dotsBox.appendChild(b);
        })(i);
      }
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-ah-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
